import { useState, useEffect } from 'react';
import axios from 'axios';

// Validates the currently-applied promo code (if any) against the given
// subtotal (the post-offer total), and returns its discount. Revalidates
// automatically whenever the code or subtotal changes, so an applied code
// is never trusted blindly if the cart changes — matches the same
// "recompute fresh" approach used for offer pricing.
const usePromoDiscount = (code, subtotal) => {
    const [result, setResult] = useState(null); // { valid, discountAmount, message } | null

    useEffect(() => {
        if (!code || !subtotal) {
            setResult(null);
            return;
        }
        const validate = async () => {
            try {
                const { data } = await axios.post('/api/v1/apply-promo-code', { code, subtotal });
                setResult({ valid: true, discountAmount: data.discountAmount, freeDelivery: data.freeDelivery });
            } catch (error) {
                setResult({ valid: false, message: error?.response?.data?.message || "Invalid promo code" });
            }
        };
        validate();
    }, [code, subtotal]);

    return result;
};

export default usePromoDiscount;
